import { useMemo } from 'react';
import { DataTestId } from '../../../layout/DataTestIdWrapper';
import { Flex } from '../../../layout/Flex';
import { Typography } from '../../../typography/Typography';
import {
    descriptionStatusColorMap,
    descriptionStatusTextMap,
    descriptionStatusIconMap,
} from '../constants';
import { DescriptionStatusProps } from '../types';

export const DescriptionStatus = ({ status }: DescriptionStatusProps) => {
    const text = useMemo(() => descriptionStatusTextMap[status], [status]);
    const Icon = useMemo(() => descriptionStatusIconMap[status], [status]);
    const color = useMemo(() => descriptionStatusColorMap[status], [status]);

    if (!text || !Icon || !color) {
        return null;
    }

    return (
        <Flex mb={1} direction="row" dataTestId={DataTestId.DESCRIPTION_STATUS}>
            <Icon size={16} color={color} />
            <Typography pl={0.5} variant="body2" weight="medium" color={color}>
                {text}
            </Typography>
        </Flex>
    );
};
